import Cookies from 'js-cookie';

export default class UploadPhoto {
	constructor(container) {
		this.container = container;
		this.uploader = this.container.querySelector('.photos__uploader');
		this.photos = this.container.querySelector('.photos__uploaded_photos');
		this.limit_reached_message = this.container
			.querySelector('.photos__uploader__limit_reached_message');

		if (this.uploader) {
			this.input = this.uploader.querySelector('input[type="file"]');
			this.limit = parseInt(this.uploader.dataset.limit, 10);

			const appendPhoto = event => {
				const form_data = new FormData;

				let files;
				switch (event.type) {
					case 'drop':
						files = this.selectFileFromDrop(event);
						break;
					default:
						files = event.target.files;
				}

				form_data.append('session_key', Cookies.get('session_key'));
				form_data.append('photo[image]', new Blob(files), files[0].name);
				this.uploader.querySelectorAll('input[type="hidden"]').forEach(
					input => {
						form_data.append(input.getAttribute('name'), input.value);
					}
				);

				// Show a loading image while the photo loads
				const loading_fake_image = `
					<div
						class="
							photos__uploaded_photos__photo
							photos__uploaded_photos__photo--fake
						"
					>
						<img src="/images/icons/fake-loading-photo.svg">
					</div>
				`.trim();
				this.photos.insertAdjacentHTML('beforeend', loading_fake_image);

				// Hide the dropzone and show the limit message for entry field
				if (
					this.limit_reached_message &&
					this.photos.querySelectorAll(
						'.photos__uploaded_photos__photo'
					).length >= this.limit
				) {
					this.limit_reached_message.classList.remove('hidden');
					this.container.querySelector('[class*="dropzone"]')
						.classList.add('hidden');
					this.input.value = '';
					this.input.removeEventListener('change', appendPhoto);
				}

				fetch(
					this.uploader.dataset.action,
					{ method: 'POST', credentials: 'same-origin', body: form_data }
				)
					.then(response => response.json())
					.then(json => {
						// Replace the fake loading image with the real one
						document.querySelector(
							'.photos__uploaded_photos__photo--fake'
						).remove();
						this.photos.insertAdjacentHTML('beforeend', json.data.trim());
					});
			};

			const deletePhoto = event => {
				event.stopImmediatePropagation();
				event.preventDefault();

				const button = event.target;
				const photo = button.closest('.photos__uploaded_photos__photo');

				fetch(
					button.dataset.action,
					{ method: 'DELETE', credentials: 'same-origin' }
				)
					.then(() => photo.remove())
					.then(() => {
						const limit_not_reached =
							this.photos.querySelectorAll(
								'.photos__uploaded_photos__photo'
							).length < this.limit;
						if (limit_not_reached) {
							this.input.addEventListener('change', appendPhoto);

							// Show the dropzone and hide the limit message for entry field
							if (this.limit_reached_message) {
								this.limit_reached_message.classList.add('hidden');
								this.container.querySelector('[class*="dropzone"]')
									.classList.remove('hidden');
							}
						}
					});
			};

			this.photos.querySelectorAll('.photos__uploaded_photos__photo .delete')
				.forEach(
					button => button.addEventListener('click', deletePhoto)
				);

			this.observer = new MutationObserver((mutationList, observer) => {
				for (const mutation of mutationList) {
					if (mutation.type === 'childList') {
						const photo =
							Array
								.from(mutation.addedNodes)
								.find(node => (
									node.classList.contains('photos__uploaded_photos__photo')
								));

						if (photo) {
							const deletePhotoButton =
								photo.querySelector('.delete[data-action]');

							if (deletePhotoButton) {
								deletePhotoButton.addEventListener('click', deletePhoto);
							}
						}
					}
				}
			});

			this.observer.observe(this.photos, { childList: true });
			if (
				this.photos.querySelectorAll(
					'.photos__uploaded_photos__photo'
				).length < this.limit
			) {
				this.input.addEventListener('change', appendPhoto);
			}

			// Set the "upload" button handler
			const upload_button = this.container
				.querySelector('.photos__uploader__dropzone__text > button');
			if (upload_button) {
				upload_button.onclick = () => {
					this.input.click();
				};
			}

			// Set up the file dropzone behavior
			const dropzone =
				this.container.querySelector('.photos__uploader__dropzone');
			if (dropzone) {
				// This is needed for "ondrop" to work
				// https://stackoverflow.com/a/51437194/11184172
				dropzone.ondragover = function(e) {
					e.preventDefault();
				};

				dropzone.ondrop = function(e) {
					e.preventDefault();
					appendPhoto(e);
				};
			}
		}
	}

	selectFileFromDrop(event) {
		if (event.dataTransfer.items) {
			const current_item = event.dataTransfer.items[0];
			if (current_item.kind === 'file') {
				return [current_item.getAsFile()];
			}
		}
	}
}
